import { Box, IconButton, styled } from '@mui/material';

import CustomInput from 'components/CustomInput';

export const ProductsListWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  backgroundColor: theme.palette.background.main,
  height: '400px',
  overflow: 'auto',
}));

export const ProductsWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.secondary,
}));

export const FilterBar = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: theme.palette.background.main,
  padding: theme.spacing(1),
}));

export const FilterInput = styled(CustomInput)(({ theme }) => ({
  margin: theme.spacing(1, 1),
  '& .MuiOutlinedInput-input': {
    padding: theme.spacing(0, 2),
  },
}));

export const DeleteButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.primary.main,
}));
